import { HiGift, HiShoppingBag, HiStar } from "react-icons/hi";
import { HiSparkles } from "react-icons/hi2";

interface StampProps {
  date?: string;
  reason?: "ORDER" | "REVIEW" | "EVENT" | "SIGNUP";
  index: number;
  isEmpty?: boolean;
}

const STAMP_STYLES = {
  ORDER: {
    bgColor: "bg-blue-100",
    icon: <HiShoppingBag className="text-blue-500" />,
  },
  REVIEW: {
    bgColor: "bg-yellow-100",
    icon: <HiStar className="text-yellow-500" />,
  },
  EVENT: {
    bgColor: "bg-green-100",
    icon: <HiGift className="text-green-500" />,
  },
  SIGNUP: {
    bgColor: "bg-violet-100",
    icon: <HiSparkles className="text-violet-600" />,
  },
} as const;

const getStampStyle = (reason: "ORDER" | "REVIEW" | "EVENT" | "SIGNUP") =>
  STAMP_STYLES[reason];

const getShadowStyle = (index: number): string => {
  if (index + 1 >= 10 && (index + 1) % 10 === 0) {
    return "shadow-[0_1px_8px_rgba(21,98,252,0.9)]";
  }
  return "shadow-sm";
};

const EmptyStamp = ({ index }: { index: number }) => {
  const shadowStyle = getShadowStyle(index);
  const isCouponPoint = index + 1 >= 10 && (index + 1) % 10 === 0;

  return (
    <div className="flex flex-col items-center gap-1">
      <div
        className={`relative w-7 h-7 border border-gray-200 rounded-full flex items-center justify-center bg-gray-50 ${shadowStyle}`}
      >
        <div className="w-4 h-4 border-2 border-gray-200 rounded-full" />
      </div>
      {isCouponPoint && (
        <span className="text-xs text-blue-500 font-medium bg-white border border-blue-500 rounded-full px-1.5 py-0.5 mt-0.5">
          1,000₩
        </span>
      )}
    </div>
  );
};

const Stamp = ({ date, reason, index, isEmpty }: StampProps) => {
  const isCouponPoint = index + 1 >= 10 && (index + 1) % 10 === 0;

  if (isEmpty) {
    return <EmptyStamp index={index} />;
  }

  if (!date || !reason) {
    return <EmptyStamp index={index} />;
  }

  const { bgColor, icon } = getStampStyle(reason);
  const shadowStyle = getShadowStyle(index);

  return (
    <div className="flex flex-col items-center gap-1">
      <div
        className={`relative w-7 h-7 border border-gray-300 rounded-full flex items-center justify-center bg-white ${shadowStyle}`}
      >
        <div
          className={`w-full h-full ${bgColor} rounded-full flex items-center justify-center`}
        >
          {icon}
        </div>
      </div>
      {isCouponPoint && (
        <span className="text-xs text-blue-500 font-medium bg-white border border-blue-500 rounded-full px-1.5 py-0.5 mt-0.5">
          1,000₩
        </span>
      )}
    </div>
  );
};

export default Stamp;
